import { Dialog } from '@halo/ui-react';

export interface RootProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  children: React.ReactNode;
  contentProps?: Dialog.ContentProps;
}

export function Root({ isOpen, setIsOpen, children, contentProps }: RootProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(details) => setIsOpen(details.open)}
      closeOnInteractOutside={false}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content borderRadius="xl" w="800px" maxW="100%" {...contentProps}>
          {children}
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
